import type { OrganizationRoleValue } from '../session/useSession';

export const ORGANIZATION_ROLE_OPTIONS: {
  value: OrganizationRoleValue;
  label: string;
  description: string;
}[] = [
  {
    value: 'ADMIN',
    label: 'Admin',
    description: 'Full access to organization settings, members, and data.',
  },
  {
    value: 'MAINTAIN',
    label: 'Maintain',
    description: 'Manage settings and members without deleting the organization.',
  },
  {
    value: 'WRITE',
    label: 'Write',
    description: 'Create and update projects, teams, and work.',
  },
  {
    value: 'READ',
    label: 'Read',
    description: 'View-only access.',
  },
];

const organizationRolePriority: Record<OrganizationRoleValue, number> = {
  READ: 1,
  WRITE: 2,
  MAINTAIN: 3,
  ADMIN: 4,
};

export const formatOrganizationRoleLabel = (role: OrganizationRoleValue) =>
  ORGANIZATION_ROLE_OPTIONS.find((option) => option.value === role)?.label ??
  role;

const hasOrganizationRole = (
  current: OrganizationRoleValue | null | undefined,
  required: OrganizationRoleValue
) => {
  if (!current) return false;
  return (
    organizationRolePriority[current] >= organizationRolePriority[required]
  );
};

export const canManageOrganizationSettings = (
  role: OrganizationRoleValue | null | undefined
) => hasOrganizationRole(role, 'MAINTAIN');

export const canManageOrganizationMembers = (
  role: OrganizationRoleValue | null | undefined
) => hasOrganizationRole(role, 'MAINTAIN');
